import {CSSProperties, useEffect, useState} from 'react'
import {KTIcon} from '@/_metronic/helpers'
import {LuwieChatPanel} from './LuwieChatPanel'

const FAB_STYLE: CSSProperties = {
  position: 'fixed',
  bottom: 88,
  right: 20,
  zIndex: 1000,
  width: 56,
  height: 56,
  borderRadius: '50%',
  border: 'none',
  background: 'var(--bs-primary)',
  color: '#fff',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  boxShadow: '0 4px 16px rgba(0,0,0,0.2)',
  cursor: 'pointer',
}

const PANEL_STYLE: CSSProperties = {
  position: 'fixed',
  bottom: 156,
  right: 20,
  zIndex: 1000,
  width: 360,
  maxWidth: '90vw',
  height: 480,
  maxHeight: 'calc(100vh - 176px)',
  display: 'flex',
  flexDirection: 'column',
  background: '#fff',
  borderRadius: 12,
  boxShadow: '0 8px 30px rgba(0,0,0,0.15)',
  overflow: 'hidden',
}

export function LuwieWidget() {
  const [open, setOpen] = useState(false)
  const [initialQuestion, setInitialQuestion] = useState<string | undefined>(undefined)

  // Buka chat panel dari luar (mis. search box header) via event 'luwie:open'
  useEffect(() => {
    const onOpen = (e: Event) => {
      const question = (e as CustomEvent).detail?.question
      setInitialQuestion(typeof question === 'string' ? question : undefined)
      setOpen(true)
    }
    window.addEventListener('luwie:open', onOpen)
    return () => window.removeEventListener('luwie:open', onOpen)
  }, [])

  return (
    <>
      {open && (
        <div style={PANEL_STYLE}>
          <LuwieChatPanel onClose={() => setOpen(false)} initialQuestion={initialQuestion} />
        </div>
      )}
      <button
        type='button'
        style={FAB_STYLE}
        onClick={() => setOpen((v) => !v)}
        title='Buka LUWIE'
        aria-label='Buka LUWIE'
      >
        <KTIcon iconName='artificial-intelligence' className='fs-2 text-white' />
      </button>
    </>
  )
}
